export default __webpack_public_path__ + "static/media/Logo Trato.6a4fc74f.svg";